const breakpoints = {
    small: '576px',
    medium: '768px',
    large: '992px',
    xLarge: '1200px',
    xxLarge: '1376px',
}; // TODO: Get rid of this

export const breakpointNumbers = {
    small: 576,
    medium: 768,
    large: 992,
    xLarge: 1200,
    xxLarge: 1366, // 16:9 ratio for most laptop's 1024 resolutions
};

export const mediaQueries = {
    xxl: `screen and (min-width: ${breakpointNumbers.xxLarge}px)`,
    xl: `screen and (min-width: ${breakpointNumbers.xLarge}px)`,
    lg: `screen and (min-width: ${breakpointNumbers.large}px)`,
    md: `screen and (min-width: ${breakpointNumbers.medium}px)`,
    sm: `screen and (min-width: ${breakpointNumbers.small}px)`,
    smDown: `screen and (max-width: ${breakpointNumbers.medium - 1}px)`,
};

export default breakpoints;
